import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

import { getTagsDiff, sortTagsAsc } from './helpers'

const useTransactionTags = ({ returnId, initialTags, setToastInfo }) => {
  const { t } = useTranslation()
  const [tags, setTags] = useState(sortTagsAsc(initialTags))
  const { fetchData: addTags } = useFetch(returnsServices.addTransactionTags, { doInitialRequest: false })
  const { fetchData: removeTag } = useFetch(returnsServices.removeTransactionTag, { doInitialRequest: false })

  useEffect(() => {
    setTags(sortTagsAsc(initialTags))
  }, [initialTags])

  const handleChange = async nextTags => {
    const prevTags = tags
    const sortedNext = sortTagsAsc(nextTags)

    setTags(sortedNext)

    const { added, removed } = getTagsDiff(prevTags, sortedNext)

    try {
      if (added.length) {
        await addTags({ returnId, names: added })
      }

      if (removed) {
        await removeTag({ returnId, name: removed })
      }
    } catch {
      setToastInfo({ show: true, message: t('Error al actualizar los tags'), type: 'error' })
    }
  }

  return { tags, handleChange }
}

export default useTransactionTags
